import { render, staticRenderFns } from "./NewDUeditorPreview.vue?vue&type=template&id=20143402&"
import script from "./NewDUeditorPreview.vue?vue&type=script&lang=js&"
export * from "./NewDUeditorPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports